export default __webpack_public_path__ + "static/media/icon-dollar-sign.cb7c8c0e.svg";